import React, {Component} from 'react';
import {SelectWithSearch} from "./SelectWithSearch";
import { withTranslation } from 'react-i18next';

export const SPECIAL_ITEM_CREATE_NEW_ACCOUNT = "CREATE_NEW_ACCOUNT";
export const SPECIAL_ITEM_LINK_TO_CONNECTION = "LINK_TO_CONNECTION";

export const CHANNEL_ACCOUNT_SELECT_SPECIAL_ITEMS = [SPECIAL_ITEM_CREATE_NEW_ACCOUNT, SPECIAL_ITEM_LINK_TO_CONNECTION];

export const DATA_BY_SPECIAL_ITEM = {
    [SPECIAL_ITEM_CREATE_NEW_ACCOUNT]: {
        text: "[Configurar una nueva cuenta]",
        className: "special-item"
    },
    [SPECIAL_ITEM_LINK_TO_CONNECTION]: {
        text: "[Conectar GA4 para ver cuentas ↗️]",
        className: "special-item"
    }
};


export class ChannelAccountSelectClass extends Component {
    constructor(props) {
        super(props);

        this.handleSelectedOptionChange = this.handleSelectedOptionChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            selectedAccount: this.props.selectedAccount
        })
    }

    getNotSelectableOptions(){
        return [SPECIAL_ITEM_LINK_TO_CONNECTION];
    }

    handleSelectedOptionChange(newOption) {
        const selectedAccountId = newOption.id;
        const selectedAccountName = newOption.text !== null ? newOption.text.split(" (")[0] : null;

        if(selectedAccountId === SPECIAL_ITEM_LINK_TO_CONNECTION) {
            window.open('/agency/conections', '_blank');
            return;
        }
        this.props.onAccountChange(selectedAccountId, selectedAccountName)
    }

    hasNotAccess(account) {
        if(account.has_access === undefined)
            return false;

        if(account.has_access === null)
            return false;

        return !account.has_access;
    }

    convertAccountsToSelectOptions () {
        const { t } = this.props;
        if(!this.props.allAccounts)
            return [];

        return this.props.allAccounts.map((account) => {
            return {
                "id": account["id"],
                "text": account["name"] +" (ID: " + account["id"] + ")" + (this.hasNotAccess(account)? `  [${t('channel_account_select.no_connection')}]` : ""),
            };
        });
    }

    addNewAccountOption(options) {
        const { t } = this.props;
        if(this.props.canCreateNewAccount !== true)
            return;

        const newAccountOption = {
            id: SPECIAL_ITEM_CREATE_NEW_ACCOUNT,
            text: t('channel_account_select.configure_new_account'),
            className: "special-item"
        };

        options.unshift(newAccountOption);
    }

    addLinkToConnectOption(options) {
        const { t } = this.props;
        if(this.props.addLinkToConnectOption !== true)
            return;

        const newAccountOption = {
            id: SPECIAL_ITEM_LINK_TO_CONNECTION,
            text: t('channel_account_select.connect_ga4_to_see_accounts'),
            className: "special-item"
        };

        options.unshift(newAccountOption);
    }

    render() {
        const { t } = this.props;
        if (this.props.allAccounts !== null) {
            const options = this.convertAccountsToSelectOptions();
            this.addNewAccountOption(options);
            this.addLinkToConnectOption(options);
            return <SelectWithSearch
                                    blackSelection={this.props.blackSelection}
                                     optionosNotSelectable={this.getNotSelectableOptions()}
                                     options={options}
                                     selected={this.props.selectedAccount}
                                     onSelectOptionChange={this.handleSelectedOptionChange}
                                     showFormValidationTexts={this.props.showFormValidationTexts}
                                     optionsVersion={this.props.channel}
            />
        } else {
            return <p>{t('common.loading')}</p>
        }
    }
}

export const ChannelAccountSelect = withTranslation()(ChannelAccountSelectClass);
export default ChannelAccountSelect;
